import { ContentMarker } from 'style/styled-components/reusable.css';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { fontBold, fontExtraBold } from 'style/styled-components/cssGlobalVariables';
import { hexToRgba } from 'utils/fnColors';

export const ModalDetails = styled.div<{ isVisible: boolean; isScrollable: boolean }>`
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
    top: ${(props) => (props.isScrollable ? 0 : 50)}%;
    left: 50%;
    transform: ${(props) => (props.isScrollable ? 'translate(-50%, 0)' : 'translate(-50%, -50%)')};
    padding-top: ${(props) => (props.isScrollable ? 48 : 0)}px;
    padding-left: 16px;
    padding-right: 16px;
    gap: 16px;

    strong {
        font-family: ${fontBold};
    }

    & div:focus-visible {
        outline: 2px solid #fff;
        border-radius: 5px;
    }

    ${MQ(Breakpoints.xs)} {
        padding-left: 120px;
        padding-right: 120px;
    }

    ${MQ(Breakpoints.s)} {
        padding: 0;
        width: auto;
        flex-direction: row;
        gap: 40px;
    }
`;

export const ModalTitleWrapper = styled.div`
    width: 100%;

    ${MQ(Breakpoints.s)} {
        display: block;
        margin: 0 auto;
        width: 480px;
    }
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: normal;
    line-height: 32px;
    width: 100%;
    padding-bottom: 4px;
    font-family: ${fontExtraBold};
    color: var(--color-primary);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${MQ(Breakpoints.xs)} {
        width: 480px;
    }

    ${MQ(Breakpoints.s)} {
        -webkit-line-clamp: 2;
    }
`;

export const ModalSubtitle = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: var(--color-primary);
    width: 100%;
    padding: 0;
    margin-bottom: 16px;
    ${MQ(Breakpoints.m)} {
        /* padding: 0 16px; */
        width: 480px;
    }
`;

export const DetailMoreAudioAndSubtitle = styled.div<{ isScrollable: boolean }>`
    height: auto;
    min-height: 100%;
    border-radius: 0;
    color: var(--color-primary);
    font-size: 16px;
    line-height: 24px;
    display: block;
    justify-content: center;
    opacity: 0.7;
`;

export const DetailMoreAudio = styled.div`
    height: auto;
    min-height: 100%;
    border-radius: 0;
    color: var(--color-primary);
    font-size: 16px;
    line-height: 24px;
    display: block;
    justify-content: center;
    padding-bottom: 16px;

    ${MQ(Breakpoints.xs)} {
        width: 480px;
        margin-right: auto;
        margin-left: auto;
    }
`;

export const DetailMoreSubtitle = styled.div`
    height: auto;
    min-height: 100%;
    border-radius: 0;
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 16px;
    line-height: 24px;
    display: block;
    justify-content: center;

    ${MQ(Breakpoints.xs)} {
        width: 480px;
        margin-right: auto;
        margin-left: auto;
    }
`;

export const ModalContentWrapper = styled.div`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    width: 252px;

    ${MQ(Breakpoints.xs)} {
        display: block;
    }
`;

export const ModalContent = styled.div`
    height: auto;
    border-radius: 0;
    color: var(--color-dark-body-70);
    font-size: 16px;
    line-height: 24px;

    ${MQ(Breakpoints.xs)} {
        margin-right: auto;
        margin-left: auto;
    }
`;

export const ChannelMeta = styled.div`
    height: auto;
    color: rgba(238, 238, 238, 0.7);
    font-size: 14px;
    line-height: 24px;
    gap: 0px 10px;
    display: flex;
    flex-wrap: wrap;

    ${MQ(Breakpoints.xs)} {
        margin-right: auto;
        margin-left: auto;
    }
`;

export const GradientBottom = styled.div`
    display: block;
    position: fixed;
    height: 88px;
    width: 100%;
    bottom: 0;
    background: linear-gradient(
        0deg,
        ${(props) => props.theme.brandedConfig.black_color} 0%,
        ${(props) => hexToRgba(props.theme.brandedConfig.black_color, 0)} 100%
    );
`;

export const DetailMoreCast = styled.div`
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-bottom: 16px;
`;

export const MetadataWrapper = styled.div`
    padding-bottom: 16px;

    &:last-child {
        padding-bottom: 0;
    }

    ${ModalContent} {
        padding: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 14px;
    }
`;

export const ModalMarkerWrapper = styled.div`
    position: relative;
    height: 24px;
    display: flex;
    gap: 10px;
    align-items: baseline;
    margin-bottom: 16px;

    ${ContentMarker} {
        position: initial;

        &:first-child {
            left: 0;
        }
    }
`;
